import { render, staticRenderFns } from "./SelectEmailTemplateSection.vue?vue&type=template&id=5177aa6a&scoped=true"
import script from "./SelectEmailTemplateSection.vue?vue&type=script&lang=js"
export * from "./SelectEmailTemplateSection.vue?vue&type=script&lang=js"
import style0 from "./SelectEmailTemplateSection.vue?vue&type=style&index=0&id=5177aa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177aa6a",
  null
  
)

export default component.exports